module.exports = __webpack_public_path__ + "static/img/temp-2.f82d3b81.jpg";